import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconName } from "@fortawesome/free-solid-svg-icons";
import { AssetFile } from "contentful";
import { TypeSectionMembershipFields } from "../../../models/contentful-content-types/section-membership";
import { TileMembershipComponent } from "../tile-membership/tile-membership.component";
import { ScrollSectionDirective } from "../../utils/directives/scroll-section.directive";

@Component({
  imports: [CommonModule, FontAwesomeModule, TileMembershipComponent, ScrollSectionDirective],
  selector: "jnguyen-section-membership",
  templateUrl: "./section-membership.component.html",
})
export class SectionMembershipComponent {
  @Input() data: TypeSectionMembershipFields;
  documentToHtmlString = documentToHtmlString;

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

  getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
